import type { ReactElement } from 'react'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import {
  avatarWrapper,
  conversationBody,
  conversationExcerpt,
  conversationHeader,
  conversationItem
} from './ConversationItem.css'

export const ConversationItemShimmer = (): ReactElement => (
  <div className={conversationItem}>
    <div className={avatarWrapper}>
      <Shimmer width={40} height={40} />
    </div>
    <div className={conversationBody}>
      <div className={conversationHeader}>
        <Shimmer width={120} height={14} />
      </div>
      <div className={conversationExcerpt}>
        <Shimmer width={180} height={12} />
      </div>
    </div>
  </div>
)
